<div class="pt-3" *ngIf="notFound">
  <h2>Event not found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!notFound && (serverError === null)">
  <div class="row">
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <span *ngIf="eventType === null">LOADING EVENT...</span>
        <span *ngIf="eventType !== null">EDIT EVENT: {{ eventType.name }}</span>
      </p>
    </div>
  </div>

  <div class="mb-5 border-rounded-10">

    <app-event-setup-nav [loadingEventType]="loadingEventType" [eventType]="eventType"></app-event-setup-nav>

    <div class="m-4" *ngIf="loadingEventType || loadingScheduleExceptions">
      <h3 class="text-muted">Loading...</h3>
    </div>

    <div class="m-4" *ngIf="!(loadingEventType || loadingScheduleExceptions)">

      <p>
        Schedule exceptions override the usual repeating schedules set in the prior “Schedules” tab. When you create a schedule exception, Capitan will remove the time slots that normally repeat on the given days and replace them with the schedule exception’s time slots.
      </p>

      <p>
        Schedule exceptions may be used when there is a reason that the typical repeating schedule needs to be modified on a particular day or days, such as holidays, wall resets, and special events.
      </p>

      <div class="rounded-table-wrapper table-responsive-lg">
        <table class="table">

          <thead>
          <tr>
            <th>Name</th>
            <th *ngIf="eventType?.schedule_type === ScheduleType.rolling">
              Roster
            </th>
            <th *ngIf="eventType?.schedule_type !== ScheduleType.rolling">
              Pricing Matrix
            </th>
            <th>Duration</th>
            <th>Location</th>
            <th>Time Slots</th>
            <th>Dates</th>
        <th></th>
          </tr>
          </thead>

          <tbody>
          <tr *ngFor="let se of scheduleExceptions">
            <td>
              {{ se.name }}
              <span *ngIf="!se.name" class="text-muted">None</span>
            </td>
            <td *ngIf="eventType?.schedule_type === ScheduleType.rolling">
              {{ se.roster_name }}
              <span *ngIf="!se.roster_name" class="text-muted">All Rosters</span>
            </td>
            <td *ngIf="eventType?.schedule_type !== ScheduleType.rolling">
              {{ se.pricing_matrix_name }}
              <span *ngIf="!se.pricing_matrix_name" class="text-muted">None</span>
            </td>
            <td>
              <ng-container *ngIf="se.duration_minutes !== null">
                {{ getDurationText(se.duration_minutes) }}
              </ng-container>
              <span *ngIf="se.duration_minutes === null" class="text-muted">
                None
              </span>
            </td>
            <td>{{ se.location_name }}</td>
            <td>
              <ng-container *ngFor="let timeSlot of se.time_slots.slice(0, 4)">
                {{ timeSlot }}
                <br>
              </ng-container>
              <i *ngIf="se.time_slots.length > 4">
                + {{ se.time_slots.length - 4}}
                more time slot{{ se.time_slots.length > 5 ? 's' : '' }}
              </i>
              <span *ngIf="se.time_slots && (se.time_slots.length === 0)"
                    class="text-muted">
                None
              </span>
            </td>
            <td>
              <ng-container *ngFor="let dateStr of se.dates.slice(0, 4)">
                {{ dateStringFromISO8601(dateStr) }}
                <br>
              </ng-container>
              <i *ngIf="se.dates.length > 4">
                + {{ se.dates.length - 4}}
                more date{{ se.dates.length > 5 ? 's' : '' }}
              </i>
            </td>
            <td class="table-button-cell">
              <button class="btn btn-danger btn-sm float-right"
                    (click)="removeScheduleException(se)">
                Remove
              </button>
              <a class="btn btn-primary btn-sm float-right mr-2"
                    [routerLink]="'/events/setup/edit/' + eventType?.id + '/schedule-exceptions/' + se.id.toString()">
                Edit
              </a>
            </td>
          </tr>
          <tr *ngIf="scheduleExceptions.length === 0">
            <td colspan="99" class="text-muted">No Schedule Exceptions</td>
          </tr>
          </tbody>

        </table>
      </div>

      <div class="row">
        <div class="col">
          <a class="btn btn-outline-primary mb-4"
                  [routerLink]="'/events/setup/edit/' + eventType?.id + '/schedule-exceptions/add'">
            Add Schedule Exception
          </a>
        </div>
      </div>

      <div class="float-right">
        <a class="btn btn-primary"
           *ngIf="eventType?.schedule_type === ScheduleType.rolling"
           [routerLink]="'/events/setup/edit/' + eventType?.id + '/columns'">
          Continue
        </a>
        <a class="btn btn-primary"
           *ngIf="eventType?.schedule_type !== ScheduleType.rolling"
           [routerLink]="'/events/setup/edit/' + eventType?.id + '/questions'">
          Continue
        </a>
      </div>
      <a [routerLink]="['/events/setup/event-types']"
         [queryParams]="{status: eventType?.status}"
         class="btn btn-secondary">
        Back
      </a>

    </div>

  </div>

</div>
